import React from 'react';
import '../App.css'; // 引入樣式文件
import { useTranslation } from 'react-i18next';

function PS() {
  const { t } = useTranslation(); // 預設使用 'translation' namespace

  return (
    <div className="article-container">
      <h1>{t('ps.title')}</h1>

      <p>{t('ps.paragraph1')}</p>

      <h2>{t('ps.interpretationHeading')}</h2>
      <p>{t('ps.paragraph2')}</p>

      <h2>{t('ps.formulaHeading')}</h2>
      <p>{t('ps.paragraph3')}</p>
      <p>{t('ps.or')}</p>
      <p>{t('ps.paragraph4')}</p>

      <h2>{t('ps.whyImportantHeading')}</h2>
      <ul>
        <li>{t('ps.whyImportantList.lowPS')}</li>
        <li>{t('ps.whyImportantList.highPS')}</li>
      </ul>

      <h2>{t('ps.exampleHeading')}</h2>
      <p>{t('ps.paragraph5')}</p>
      <ul>
        <li>{t('ps.exampleList.sales')}</li>
        <li>{t('ps.exampleList.marketValue')}</li>
      </ul>
      <p>{t('ps.exampleCalculation')}</p>
      <p>{t('ps.exampleExplanation')}</p>
    </div>
  );
}

export default PS; // 定義內聯樣式
export const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 37px)',
    height: 'calc(100vh - 37px)',
    padding: '20px',
    marginTop: 0,
    backgroundColor: '#f8f9fa',
    top: '37px',
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'auto',
  },
  card: {
    width: '90%',
    maxWidth: '380px',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    padding: '30px',
    transition: 'transform 0.3s ease',
    position: 'relative',
  },
  header: {
    textAlign: 'center',
    marginBottom: '25px',
  },
  title: {
    color: '#333',
    fontSize: '26px',
    marginBottom: '8px',
    fontWeight: 600,
  },
  subtitle: {
    color: '#666',
    fontSize: '15px',
  },
  error: {
    backgroundColor: '#fff0f0',
    color: '#e74c3c',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '15px',
    fontSize: '14px',
    borderLeft: '4px solid #e74c3c',
    width: '85%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '18px',
    width: '100%',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    width: '85%',
    maxWidth: '300px',
    gap: '6px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#333',
    alignSelf: 'flex-start',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '15px',
    transition: 'border-color 0.3s',
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '10px',
    width: '85%',
    maxWidth: '300px',
  },
  emailButton: {
    width: '150px',
    padding: '11px',
    backgroundColor: '#2a7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  emailInput: {
    width: '200px',
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '15px',
    transition: 'border-color 0.3s',
  },
  formActions: {
    width: '85%',
    maxWidth: '300px',
    marginTop: '5px',
  },
  button: {
    width: '100%',
    padding: '11px',
    backgroundColor: '#8e7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '85%',
    maxWidth: '300px',
    marginTop: '15px',
    fontSize: '13px',
  },
  link: {
    color: '#8e7a55',
    textDecoration: 'none',
    transition: 'color 0.3s',
  },
  backButton: {
    position: 'absolute',
    top: '15px',
    left: '15px',
    background: 'none',
    border: 'none',
    color: '#8e7a55',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
  },
  backIcon: {
    marginRight: '5px',
  },
  // 模態框樣式
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    maxWidth: '350px',
    width: '90%',
    textAlign: 'center',
    position: 'relative',
  },
  modalHeader: {
    marginBottom: '15px',
    color: '#8e7a55',
    fontSize: '20px',
    fontWeight: 600,
  },
  modalText: {
    marginBottom: '20px',
    fontSize: '15px',
    lineHeight: '1.5',
    color: '#555',
  },
  modalButton: {
    padding: '8px 20px',
    backgroundColor: '#8e7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  modalCloseButton: {
    position: 'absolute',
    top: '10px',
    right: '15px',
    background: 'none',
    border: 'none',
    fontSize: '22px',
    color: '#999',
    cursor: 'pointer',
    lineHeight: 1,
  },
};
